import palette from '../palette'

export const drawerWidth = 240

export default {
	width: drawerWidth,
	flexShrink: 0,
	whiteSpace: 'nowrap',
	boxSizing: 'border-box',

	'.MuiDrawer-paper': {
		backgroundColor: palette.sidebar.gray, // Set your desired background color
	},
}
